"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadButton = void 0;
var react_1 = require("react");
var axios_1 = require("axios");
var reactstrap_1 = require("reactstrap");
var React = require("react");
var FileUploadButton = function (props) {
    var _a = react_1.useState(""), file = _a[0], setFile = _a[1];
    var _b = react_1.useState(null), fileName = _b[0], setFileName = _b[1];
    var fileInput = react_1.useRef(null);
    var saveFile = function (e) {
        console.log(e.target.files[0]);
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);
        uploadFile(e);
    };
    var uploadFile = function (e) {
        console.log(file);
        var formData = new FormData();
        if (file != null) {
            formData.append("Logo", file);
            try {
                var headerObj = {
                    'content-type': "multipart/form-data;",
                };
                if (file != null) {
                    headerObj['content-type'] = headerObj['content-type'] + ' boundary=${formData._boundary}';
                }
                axios_1.default.put(props.url, formData, {
                    headers: headerObj
                }).then(function (res) {
                    console.log(res);
                    props.callback(res.data);
                });
            }
            catch (ex) {
                console.log(ex);
            }
        }
    };
    //
    var handleClick = function () {
        fileInput.current.click();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { ref: fileInput, onChange: saveFile, type: "file", style: { display: "none" } }),
        React.createElement(reactstrap_1.Button, { onClick: handleClick }, "Upload File")));
};
exports.FileUploadButton = FileUploadButton;
//# sourceMappingURL=FileUploadButton.js.map